export default "__VITE_PUBLIC_ASSET__105f958b__"